export default class ErrorCodes {

  static get hrErrorCode() {
    return {
      //100
      100: 'error on HTML5 media element',
      104: 'invalid license key',
      105: 'cannot find player container element on page',
      106: 'cannot find player container PARENT on page',
      107: 'no playback support',
      //200
      200: 'failed to load required library hls.js',
      201: 'hls.js fatal error - general error',
      202: 'Google IMA DAI backup stream not provided',
      203: 'hls.js fatal error - manifest parsing error',
      204: 'hls.js fatal error - network error',
      205: 'hls.js fatal error - incompatible codecs error',
      206: 'hls.js fatal error - decoding media error',
      //300
      300: 'failed to load required library Shaka player',
      301: 'Shaka player fatal error',
      302: 'cannot use Shaka player in this environment',
      303: 'Shaka player fatal error - error from the network stack',
      304: 'Shaka player fatal error - error from parsing text streams',
      305: 'Shaka player fatal error - error parsing or processing audio or video streams',
      306: 'Shaka player fatal error - error parsing the manifest',
      307: 'Shaka player fatal error - error related to streaming',
      308: 'Shaka player fatal error - errors related to DRM',
      309: 'Shaka player fatal error - error in the database storage (offline)',
      //500
      500: 'failed to load required library three.js (360 video)',
      //600
      600: 'FairPlay failed to retrieve the server certificate',
      601: 'FairPlay key system not supported',
      602: 'FairPlay could not create MediaKeys',
      603: 'FairPlay could not create key session',
      604: 'FairPlay license request failed',
      // 700 playlist/related
      700: 'failed at loading playlistLoc URI',
      701: 'failed at parsing JSON playlist',
      702: 'failed at parsing JSON playlist - no playlist property',
      703: 'empty playlist - exit',
      704: 'cannot append playlist layout - missing rmp-playlist-container container',
      705: 'failed at setPlaylistData - invalid input',
      706: 'failed at setPlaylistData - internal error',
      707: 'failed at setPlaylistLoc - invalid input',
      708: 'failed at setPlaylistLoc - internal error',
      709: 'failed at setPlaylistItem - error while trying to load and play new item',
      710: 'failed at loading relatedLoc URI',
      711: 'failed at parsing JSON related',
      712: 'failed at parsing JSON related - no playlist property',
      713: 'empty related list - exit',
      714: 'failed at setRelatedData - invalid input',
      715: 'failed at setRelatedData - internal error',
      716: 'failed at setRelatedLoc - invalid input',
      717: 'failed at setRelatedLoc - internal error',
      718: 'failed at setRelatedItem - error while trying to load and play new item',
      // 800 misc
      800: 'cannot append transcript layout - wrong HTML layout'
    };
  }

  static get hrWarningCode() {
    return {
      //1000 - general player warning
      1000: 'failed to load logo at provided URI',
      1001: 'failed to load poster at provided URI',
      1002: 'failed to load animated poster at provided URI',
      1003: 'invalid input for this API call',
      1004: 'player not ready - cannot execute API call',
      1005: 'autoplay requested but player failed at playing content',
      1006: 'init method already called for this player instance - exit',
      1009: 'failed to enter picture to picture mode',
      1010: 'warning on HTML5 media element',
      1011: 'videoPlayPromise on content has failed - error message follows',
      1012: 'not ready - cannot initiate playback - exit',
      1013: 'destroy method currently running - wait for destroycompleted event',
      1014: 'internal - call to play() API Promise has rejected - error message follows',
      1015: 'internal - call to stop() API Promise has rejected - error message follows',
      1016: 'internal - call to seekTo() API Promise has rejected - error message follows',
      1017: 'internal - call to setFullscreen() API Promise has rejected - error message follows',
      1018: 'internal - call to dvrSeekTo() API Promise has rejected - error message follows',
      1019: 'internal - call to syncToLiveEdge() API Promise has rejected - error message follows',
      1020: 'internal - call to loadAds() API Promise has rejected - error message follows',
      1021: 'internal - call to stopAds() API Promise has rejected - error message follows',
      1022: 'internal - call to destroy() API Promise has rejected - error message follows',
      1023: 'internal - call to setPlaylistItem() API Promise has rejected - error message follows',
      1024: 'internal - call to setRelatedItem() API Promise has rejected - error message follows',
      1025: 'internal - call to setSrc() API Promise has rejected - error message follows',
      1026: 'cannot use setPlayerSize when player is in fullscreen - exit',
      1027: 'cannot use setPlayerSize with autoHeightMode or iframeMode settings - exit',
      1028: 'failed at locking orientation to landscape',
      1031: 'cannot use seekTo with a live stream - exit',
      1032: 'cannot use seekTo while a linear ad is playing - exit',
      1033: 'to seek into a DVR stream use dvrSeekTo method - exit',
      1034: 'error trying to set currentTime on HTML5 media element',
      1035: 'dvrSeekTo requires a DVR stream - exit',
      1036: 'cannot use dvrSeekTo while a linear ad is playing - exit',
      1037: 'cannot use syncToLiveEdge while a linear ad is on stage - exit',
      1038: 'cannot use dvrSeekTo - invalid content duration - exit',
      1040: 'cannot use seekToFrame - content is not on-demand - exit',
      1041: 'cannot use seekToFrame - invalid currentTime or duration - exit',
      1050: 'cannot use quality setter while a linear ad is playing',
      //2000 - hls.js warning
      2000: 'hls.js warning',
      2001: 'INTERSTITIAL_ASSET_ERROR in hls.js, an error resulting in an asset not playing or finishing early. Playback is expected to fallback to primary this is why this is marked as a warning and not an error',
      //3000 - Shaka player warning
      3000: 'Shaka player warning',
      3001: 'storage has not been initialized',
      3002: 'could not download offline content',
      3003: 'could not list offline downloaded content',
      3004: 'could not remove offline downloaded content',
      3005: 'could not load offline content - invalid input',
      3006: 'could not query temporary storage usage and availability',
      3007: 'offline storage is not supported in this environment',
      3008: 'could not abort download of offline content',
      3009: 'could not get Shaka Player thumbnails - no thumbnail will be displayed',
      //4000 - vtt.js warning
      4000: 'failed to load vtt.js',
      4001: 'vtt.js parsing error',
      4002: 'failed to load text track',
      4003: 'all text tracks could not be loaded - only those available will be presented to the viewer',
      //5000 - transcript warning
      5000: 'failed to load transcript file from server',
      5001: 'not a valid WebVTT file',
      //6000 - FPS warning
      6000: 'FairPlay decryption key error was encountered',
      6001: 'FairPlay video playback error occured',
      //7000 - playlist|related warning
      7000: 'playlistCallback failed',
      7001: 'cannot call setPlaylistItem - no initial playlist input',
      7010: 'relatedCallback failed',
      7011: 'cannot call setRelatedItem - no initial related input',
      //8000 - thumbnail warning
      8000: 'failed to load VTT thumbnail file',
      8001: 'failed to load sprite image',
      8002: 'not a valid VTT thumbnail file - no further action taken',
      8003: 'could not parse thumbnails VTT file - corrupted data found',
      // 9000 custom icons warning
      9000: 'error parsing JSON for custom icons',
      9001: 'error loading JSON for custom icons',
      //10000 - ads warning 
      10000: 'failed to load optional library rmp-vast - no ad will be shown',
      10001: 'failed to load optional library Google IMA SDK - no ad will be shown',
      10003: 'getAdBlock requested but ads setting is false and this is not a AWS Media Tailor stream',
      10004: 'VAST parser does not exist yet - exit',
      10005: 'Ad API call cannot be executed - ads setting is set to false',
      10012: 'cannot use loadAds with Google IMA DAI stream',
      10013: 'cannot use loadAds while Google Cast is engaged',
      10014: 'Google Ima Display Container is not initialized - cannot use loadAds',
      10015: 'rmp-vast is not initialized - cannot use loadAds',
      10016: 'loadAds failed at loading and playing ad - query adErrorMessage, adVastErrorCode, adErrorType, adErrorCode getters for more information',
      10017: 'stopAds called but no ad is on stage',
      10018: 'skipAd called but no ad is on stage',
      10019: 'Ad is not in a skippable state',
      //12000 - setSrc API warning
      12000: 'setSrc currently running - wait for srcchanged event',
      12001: 'no playback support -> cannot use setSrc - exit',
      12002: 'setSrc called but player is not ready - exit',
      12003: 'cannot use setSrc for FairPlay streaming, outstream ads - exit',
      12004: 'failed at changing player source',
      //13000 - Google Analytics
      13000: 'Google tag is not installed on this page, cannot send data to Google Analytics',
      //14000 - Floating
      14000: 'floating feature requires an anchor element, disabling floating',
      //15000 chapters
      15000: 'failed at loading chapters WEBVTT file',
      15001: 'not a valid WEBVTT file for chapters - exit',
      //16000 - cast warning
      16000: 'failed to load cast_sender.js dependency',
      16001: 'castSession.loadMedia failed on receiving device',
      16002: 'failed at selecting receiver device',
      16003: 'failed at initializing Google Cast Cordova',
      16004: 'cast media is loading - prevented play on local player',
      //17000 fullscreen warning
      17000: 'error entering fullscreen mode',
      17001: 'error exiting fullscreen mode',
      17002: 'already in fullscreen mode',
      17003: 'already in window mode (out of fullscreen mode)'
    };
  }

}
